export default "__VITE_ASSET__73be9956__"